import Cookies from "js-cookie";

const AccessTokenKey = "user_access_token";

export function getAccessToken() {
  return Cookies.get(AccessTokenKey);
}

export function setAccessToken(token) {
  return Cookies.set(AccessTokenKey, token);
}

export function removeAccessToken() {
  return Cookies.remove(AccessTokenKey);
}

const orderProgramProductGroupSelect = "order_program_product_group_select";
const orderProductSelect = "order_product_select";
const orderSelectExtraProducts = "order_select_extra_products";
const isGroupEnroll = "is_group_enroll";

export function getOrderProgramProductGroupSelect() {
  return Cookies.get(orderProgramProductGroupSelect);
}

export function setOrderProgramProductGroupSelect(data) {
  return Cookies.set(orderProgramProductGroupSelect, data);
}

export function removeOrderProgramProductGroupSelect() {
  return Cookies.remove(orderProgramProductGroupSelect);
}

export function getOrderProductSelect() {
  return Cookies.get(orderProductSelect);
}

export function setOrderProductSelect(data) {
  return Cookies.set(orderProductSelect, data);
}

export function removeOrderProductSelect() {
  return Cookies.remove(orderProductSelect);
}

export function getOrderSelectExtraProducts() {
  return Cookies.get(orderSelectExtraProducts);
}

export function setOrderSelectExtraProducts(data) {
  return Cookies.set(orderSelectExtraProducts, data);
}

export function removeOrderSelectExtraProducts() {
  return Cookies.remove(orderSelectExtraProducts);
}

export function getIsGroupEnroll() {
  return Cookies.get(isGroupEnroll);
}

export function setIsGroupEnroll(isGroup) {
  return Cookies.set(isGroupEnroll, isGroup);
}

export function removeIsGroupEnroll() {
  return Cookies.remove(isGroupEnroll);
}
